<template>
  <Card class="inventoryCheck">
    <div slot="title">
      <i-input style="width: 300px"
                :placeholder="$t('pages_product_stocks_index_737')"
                v-model="filter" />
      <!-- <el-button size="small"
                  class="batchCheck"
                  type="primary"
                  icon="el-icon-paperclip"
                  @click="showBatchCheck()">批量盘点</el-button> -->
    </div>
    <Modal v-model="modalShow"
           :mask-closable="false"
           :fullscreen="false"
           width="80%"
           :loading="batchLoading"
           @on-ok="handleBatchCheck"
           :title="$t('pages_product_stocks_index_738')">
      <Form ref="batchCheck"
            :model="batchCheck"
            :label-width="120"
            :rules="batchRules">
        <Form-item :label="$t('pages_lcsw_accounts_index_512')"
                   prop="name">
          <Input type="text"
                 :placeholder="$t('pages_product_stocks_index_739')"
                 v-model="batchCheck.name" />
        </Form-item>
      </Form>
    </Modal>
    <Table style="margin-top: 20px;"
            ref="table"
            border
            :loading="loading"
            :columns="columns"
            :data="products"></Table>
    <Row>
      <Page style="margin-top: 20px;"
            show-total
            :total="meta.total"
            :current="meta.current"
            :page-size="meta.pageSize"
            @on-change="changePage"></Page>
    </Row>
  </Card>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import {
  tableAvatar,
  booleanChinese
} from '@/libs/table-render'
import Cookies from 'js-cookie'
import { TOKEN_KEY } from '@/libs/util'
import { debounce } from 'lodash';

export default {
  data () {
    return {
      filter: '',
      headers: {
        Authorization: Cookies.get(TOKEN_KEY),
        ShopId: localStorage.getItem('SHOPID')
      },
      query: '',
      modalShow: false,
      formType: '',
      batchLoading: true,
      batchRules: {
        name: { required: true, message: i18n.t('pages_product_stocks_index_739') },
      },
      batchCheck: {},
      columns: [
        {
          title: 'ID',
          key: 'id',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_ai_thirdparty_165'),
          key: 'image',
          align: 'center',
          render: (h, params) => {
            return tableAvatar(h, params.row.image)
          }
        },
        {
          title: i18n.t('pages_ai_image_158'),
          key: 'name',
          align: 'center'
        },
        {
          title: i18n.t('pages_booking_store_products_index_220'),
          key: 'fresh_category_name',
          align: 'center'
        },
        {
          title: i18n.t('pages_ai_thirdparty_168'),
          key: 'need_to_weight',
          align: 'center',
          render: (h, params) => {
            return booleanChinese(h, params.row.need_to_weight)
          }
        },
        {
          title: i18n.t('pages_booking_store_products_index_221'),
          key: 'unit',
          align: 'center'
        },
        {
          title: i18n.t('pages_product_stocks_index_740'),
          key: 'stocks',
          width: 240,
          align: 'center',
          render: (h, params) => {
            const id = `input-${params.row.id}`
            return h('div', [
              h('Input', {
                attrs: { id },
                props: { type: "text", value: params.row.stocks },
                style: { width: '80px', 'margin-right': '30px' }
              }),
              h('Button', {
                props: { type: "warning", value: params.row.stocks },
                on: {
                  click: () => {
                    this.check_stock(params.row.id, document.getElementById(id).children[1].value)
                  }
                }
              }, i18n.t('pages_product_stocks_index_741'))
            ])
          }
        }
      ],
      debounceSearch: debounce(this.search, 300),
    }
  },
  created () {
    this.index({ is_display: 'ignore' })
  },
  computed: {
    ...mapGetters('product', ['product', 'products', 'products_all', 'meta', 'loading'])
  },
  watch: {
    filter (val) {
      this.debounceSearch();
    }
  },
  methods: {
    ...mapActions('product', [
      'clear',
      'index',
      'show',
      'destroy'
    ]),
    ...mapActions('stock', ['create']),
    ...mapMutations('product', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page: page })
      this.index({ is_display: 'ignore' })
    },
    search () {
      const filter = this.filter || '';
      this.index({
        query: filter,
        is_display: 'ignore'
      });
    },
    async check_stock (id, num) {
      await this.create({
        product_id: id,
        stocks: parseFloat(num)
      })
      await this.index({ is_display: 'ignore' })
    },
    showBatchCheck () {
      this.clear()
      this.modalShow = true
    },
    handleBatchCheck () {
      // this.create(this.product)
      this.modalShow = false
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="less">
.inventoryCheck {
  .batchCheck {
    float: right;
  }
}
</style>
